
import React from 'react';
export default function Blog016() {
  return (
    <section>
    <article>
      <h2>16. 09-19-2022</h2>
      <h3>Dungeons to Fungeons with Bootstrap</h3>
      <p>
        I have spent the last couple of days working with Bootstrap. I enjoy the 
        idea of a css framework, and I can see this making CSS tasks in the future 
        much easier. The preset formats are a bit of a challenge to change, 
        but I find the Pro's outweigh the Con's. <br />
        To learn with Bootstrap, I have developed a Website using only Bootstrap for 
        CSS configuration. I created four printable pages, intended to be printed on two 
        pieces of paper. This, along with some dice, is everything needed to play. <br />
        I have linked the game in the bottom of this post, if you'd like to check it out 
        for yourself. 
        <br /><br />
        I have updated my website, and added some @media inquiries to create a responsive 
        look. Check out my website linked at the bottom of this blog post. I am going to update 
        my resume to reflect my skills.
        <br /> <br />
        I have uploaded my second tutorial! Check it out in the links below!
        <br /><br />
        The end of this month will be my 3rd month in coding, and I am growing closer to 
        my preset goal of apply to programming jobs. I am excited to move forward and 
        make amazing applications!
        <br /> <br />
        Thanks for reading <br />
        -Eric Polley
      </p>
    </article>

    <h4>Links</h4>
    <br />
    <ul>
      <li>
        <a
          href="http://dtf.ericpolley.com"
          title="Dungeons to Fungeons"
          rel="noopener noreferrer"  
          target="_blank"
        >
          <strong><p>Dungeons to Fungeons (Download and play free!)</p></strong></a
        >
      </li>
   
      <li>
        <a
          href="http://ericpolley.com"
          rel="noopener noreferrer"  
          target="_blank"
          title="My website"
        >
          <strong><p>Check out my website</p></strong></a
        >
      </li>
      <li>
        <a
          href="https://www.youtube.com/watch?v=izItmx_utZY&list=PLce5_YZyrUw6mOXubpKKWoTROUqCfIDDo"
          title="Tutorial"
          target="_blank"
          rel="noopener noreferrer"  
        >
          <strong><p>My second Programming Tutorial</p></strong></a
        >
      </li>
    </ul>
  </section>
  )
}
